import { useMemo, useState, useCallback } from "react";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { GeoPreviewMapProps, GeoPreviewMapViewModel, FeaturePopupData } from "./GeoPreviewMap.types";
import { processFeatures } from "./GeoPreviewMap.helpers";

export function useGeoPreviewMapViewModel(props: GeoPreviewMapProps): GeoPreviewMapViewModel {
	const mapsLibrary = useMapsLibrary("maps");
	const [activePopup, setActivePopup] = useState<FeaturePopupData | null>(null);

	const handleMapClick = useCallback(() => {
		setActivePopup(null);
	}, []);

	const onFeatureClick = useCallback((position: google.maps.LatLngLiteral, properties: Record<string, unknown>) => {
		setActivePopup({ position, properties });
	}, []);

	const processedFeatures = useMemo(() => {
		return processFeatures(props.inputData, props.groupIndex);
	}, [props.inputData, props.groupIndex]);

	return {
		mapsLibrary,
		activePopup,
		processedFeatures,
		onFeatureClick,
		handleMapClick,
	};
}
